import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    '& > *': {
      margin: theme.spacing(1),
    },
  },
  cardBody: {
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
    padding: theme.spacing(0.5),
    margin: 0,
    maxHeight: '200px',
    paddingButton: theme.spacing(2),
    paddingTop: theme.spacing(2),
    overflow: 'auto'

  },
  button: {
    marginRight: '5px',
    cursor: 'pointer',
    outline: 'none',
    border: 'none',
    backgroundColor: '#333333',
    width: '200',
    height: '40px',
    borderRadius: '10px',
    fontSize: '1.5rem',
    fontWeight: 50,
    color: 'white',
    backgroundSize: '100% ',
    marginBottom: '15px',
  },
  chip: {
    margin: theme.spacing(0.5),
  },
}));

export default useStyles;
